const cz = {
    common: {
        history: "historická verze"
    }
};
export default cz;



// WEBPACK FOOTER //
// ./src/i18n/langs/cz.js